export { default } from './ScoredCardRoute'
